"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var Tip = function Tip(_ref) {
  var message = _ref.message;
  return (0, _preact.h)("div", {
    className: "tip-box"
  }, " ", message, " ");
};

var _default = Tip;
exports.default = _default;